module.exports = __webpack_public_path__ + "img/zendesk-round.a1e5c1a4.svg";